import { nanoid } from 'nanoid';
import React, { Component } from 'react';
import FormFieldProps from './FormField.props';
import FormFieldState from './FormField.state';

export default class FormField extends Component<FormFieldProps, FormFieldState> {
    constructor(props: FormFieldProps) {
        super(props);
        this.state = {
            key: 'value'
        };
    }

    componentDidMount() {
        try {
            window.Juris.moduleRegistry.autoApplyModule('Tooltip', '[data-tooltip]');
        } catch (error) {
            console.log(error);
        }
    }

    render(): React.ReactNode {
        return (
            <div className={"form__col col col-" + (this.props.colWidth || "12")} style={this.props.styles}>
                <div className="form__field">
                    {
                        this.props.info ? <>
                            <div className="form__field-info-wrapper">
                                {this.props.children}
                                <div className="form__field-info" data-tooltip={false}>
                                    <span className="icon_error-circle_alt"></span>
                                    {
                                        this.props.isInPPO 
                                            ? <div id={nanoid()} 
                                                className="form__field-info-tooltip" 
                                                data-tooltip-content={false}>
                                                <span className="icon_error-circle_alt"></span>
                                                <div className="textblock" dangerouslySetInnerHTML={{
                                                    __html: this.props.info.text
                                                }}></div>
                                                <span className="cta-overlay-button__close-btn-icon"></span>
                                            </div>
                                            : <div id={nanoid()} 
                                                className="form__field-info-tooltip" 
                                                data-tooltip-content={false} 
                                                dangerouslySetInnerHTML={{
                                                    __html: this.props.info.text
                                                }}>
                                            </div> 
                                    }
                                </div>
                            </div>
                        </> : <>
                            {this.props.children}
                        </>
                    }
                    {
                        this.props.hint
                            ? <span className="form__field-hint">{this.props.hint}</span>
                            : null
                    }
                    {
                        this.props.errorMessage
                            ? <div className="form__field-error-message">{this.props.errorMessage}</div>
                            : null
                    }
                </div>
            </div>
        );
    }
}
